<template>
  <div class="main-view" v-loading.body="loading">
    <!-- 筛选 -->
    <el-col>
      <el-form inline class="inline-form">
        <el-form-item label="交易时间">
          <date-range-picker v-model="creatTime" :value="creatTime" ref="creatTime" @getChange="dateChange"></date-range-picker>
        </el-form-item>
        <el-form-item label="商户编号">
          <el-input
            style="width:160px;"
            v-model="merchantId"
            placeholder="商户编号"
            clearable
            auto-complete="off">
          </el-input>
        </el-form-item>
        <payment-type
          :payType="searchInfo.payType"
          :payChannel="searchInfo.effectPayTypeStr"
          :isProfit="true"
          @getPayType="getPayType"
          @getPayChannel="getEffectPayType"></payment-type>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchClick">查询</el-button>
          <!--          <el-button icon="el-icon-download" :loading="exportButtonLoading" @click="exportClick">导出</el-button>-->
        </el-form-item>
      </el-form>
    </el-col>
    <!-- table -->
    <el-table
      border
      style="width:100%;"
      v-loading="tableLoading"
      show-summary
      :summary-method="dialogTableGetSummaries"
      :data="allStoreDetailSummaryList"
      max-height="490">
      <el-table-column
        prop="fMerchantId"
        label="商户编号"
        align="center"
        min-width="180">
      </el-table-column>
      <el-table-column
        prop="fShopType"
        label="店铺类型"
        align="center"
        min-width="120">
        <template slot-scope="scope">
          <div>{{ scope.row.fShopType | formatShopType }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="fMerchantName"
        label="商户简称"
        align="center"
        min-width="180">
      </el-table-column>
      <el-table-column
        prop="fShouldSettleAmount"
        label="应结订单金额"
        align="center"
        min-width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.fShouldSettleAmount ? Number(scope.row.fShouldSettleAmount / 100).toFixed(2) : 0 }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="fWeixinAmount"
        label="微信金额"
        align="center"
        min-width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.fWeixinAmount ? Number(scope.row.fWeixinAmount / 100).toFixed(2) : 0 }}元</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="fAliAmount"
        label="支付宝金额"
        align="center"
        min-width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.fAliAmount ? Number(scope.row.fAliAmount / 100).toFixed(2) : 0 }}元</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="fUnionScanAmount"
        label="银联扫码金额"
        align="center"
        min-width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.fUnionScanAmount ? Number(scope.row.fUnionScanAmount / 100).toFixed(2) : 0 }}元</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="fPosAmount"
        label="刷卡金额"
        align="center"
        min-width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.fPosAmount ? Number(scope.row.fPosAmount / 100).toFixed(2) : 0 }}元</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="fTransCount"
        label="交易笔数"
        align="center"
        min-width="150">
      </el-table-column>
      <el-table-column
        prop="fRefundAmount"
        label="退款金额"
        align="center"
        min-width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.fRefundAmount ? Number(scope.row.fRefundAmount / 100).toFixed(2) : 0 }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="fRefundCount"
        label="退款笔数"
        align="center"
        min-width="150">
      </el-table-column>
      <el-table-column
        prop="fReversalAmount"
        label="冲正金额"
        align="center"
        min-width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.fReversalAmount ? Number(scope.row.fReversalAmount / 100).toFixed(2) : 0 }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="fReversalCount"
        label="冲正笔数"
        align="center"
        min-width="150">
      </el-table-column>
      <el-table-column
        prop="fServiceFee"
        label="手续费"
        align="center"
        min-width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.fServiceFee ? Number(scope.row.fServiceFee / 100).toFixed(2) : 0 }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="fSettleAmount"
        label="结算金额"
        align="center"
        min-width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.fSettleAmount ? Number(scope.row.fSettleAmount / 100).toFixed(2) : 0 }}</div>
        </template>
      </el-table-column>
    </el-table>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
  </div>
</template>

<script>
import qs from 'qs'
import { parseTime } from '@/utils/formatTime'
import paymentType from '@/components/paymentType/paymentType'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { getTransStatistic, exportTransStatistic } from '@/api/transaction'

export default {
  name: 'AllStoreDetailSummary',
  components: {
    paymentType,
    dateRangePicker,
    pagination
  },
  data () {
    const todayStr = (parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')).substr(0, 10) + ' 23:59:59'
    const toadyZero = new Date(new Date().getTime() - 3600 * 1000 * 24)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}').substr(0, 10) + ' 00:00:00'
    return {
      loading: false,
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 20
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        merchantId: '',
        payType: 0,
        effectPayTypeStr: '2, 3, 6'
      },
      creatTime: [todayZeroStr, todayStr],
      merchantId: '',
      tableLoading: false,
      exportButtonLoading: false,
      allStoreDetailSummaryList: [],
      sumInfo: {}
    }
  },
  mounted () {
    this.getDefaultData()
  },
  beforeDestroy () {},
  methods: {
    /**
     * @description 初始加载数据方法
     */
    async getDefaultData () {
      this.loading = true
      // await this.getAllSubMerchantNames()
      await this.searchClick()
      this.loading = false
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
     * @description 筛选查询按钮点击
     */
    searchClick (noReset) {
      console.log('查询点击')
      this.setSearchInfoParams(noReset)
      this.queryCountAgentProfit()
    },
    /**
     * 导出按钮点击
     */
    exportClick () {
      console.log('导出点击')
      this.setSearchInfoParams(true)
      // const startDate = new Date(this.searchInfo.startTime)
      // const endDate = new Date(this.searchInfo.endTime)
      // if (!this.searchInfo.startTime || !this.searchInfo.endTime || endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 30) {
      if (!this.searchInfo.startTime || !this.searchInfo.endTime) {
        this.$message({
          // message: '请筛选1个月内的数据进行导出',
          message: '请筛选时间进行导出',
          type: 'error'
        })
        return
      }
      this.exportTransStatistic()
    },
    /**
     * 组装筛选参数
     */
    setSearchInfoParams (noReset) {
      this.searchInfo.startTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchInfo.endTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      this.searchInfo.merchantId = this.merchantId || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      Object.assign(this.searchInfo, this.paginations)
    },
    dateChange (value) {
      this.creatTime = value
    },
    /**
     * @description 删除提交参数中的空字段
     * @param {Object} params 搜索内容对象
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * 全部店铺明细汇总列表-合计计算方法
     */
    dialogTableGetSummaries ({ columns, data }) {
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
          return
        }
        const propertyName = column.property.replace(/( |^)[a-z]/g, (L) => L.toUpperCase())
        const totalPropertyName = `total${propertyName}`
        // eslint-disable-next-line no-prototype-builtins
        if (this.sumInfo.hasOwnProperty(totalPropertyName)) {
          if (totalPropertyName.includes('Amount') || totalPropertyName.includes('Fee')) {
            sums[index] = `${Number(this.sumInfo[totalPropertyName] / 100).toFixed(2)}元`
          } else if (totalPropertyName.includes('Count')) {
            sums[index] = this.sumInfo[totalPropertyName] + '笔'
          } else {
            sums[index] = this.sumInfo[totalPropertyName]
          }
        } else {
          sums[index] = '——'
        }
      })
      return sums
    },
    /**
     * 总分店交易统计报表
     */
    queryCountAgentProfit () {
      this.loading = true
      const params = qs.stringify(this.searchInfo)
      console.log(params)
      return new Promise((resolve, reject) => {
        getTransStatistic(params).then(response => {
          console.log('getTransStatistic response:', response)
          this.loading = false
          if (response.error_code === '0') {
            this.allStoreDetailSummaryList = response.data.list
            this.paginations.count = response.data.totalCount
            this.sumInfo = { ...response.data }
            delete this.sumInfo.list
            delete this.sumInfo.totalCount
            if (parseInt(this.paginations.count) > 10000) {
              this.$message({
                message: '最多筛选出10000条数据，请重新筛选',
                type: 'warning'
              })
            }
            resolve()
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      })
    },
    /**
     * 总分店交易统计报表导出
     */
    exportTransStatistic () {
      this.exportButtonLoading = true
      const params = qs.stringify(Object.assign({}, this.searchInfo, {
        moduleCode: 1,
        moduleName: '交易',
        menuName: '总分店交易统计'
      }))
      console.log(params)
      exportTransStatistic(params).then(response => {
        this.exportButtonLoading = false
        if (response.error_code === '0') {
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    formatDate (item) {
      return parseTime(new Date(item.fTime), '{y}-{m}-{d} {h}:{i}:{s}')
    },
    // 获取组件中交易类型及交易渠道选中值
    getPayType (val) {
      this.searchInfo.payType = val
    },
    getEffectPayType (val) {
      this.searchInfo.effectPayTypeStr = val
    }
  },
  computed: {
    roleName () {
      return this.$store.getters.roleName
    }
  },
  filters: {
    formatShopType (value) {
      switch (value) {
        case 1:
          return '总店'
        case 0:
          return '分店'
        default:
          return '未知'
      }
    }
  }
}
</script>

<style scoped>
.main-view {
  padding-left: 20px;
}
.inline-form {
  margin-top: 18px;
}
.search-input {
  width: 160px;
}
.btm-action {
  margin-top: 20px;
  text-align: center;
}
</style>
